<template>
    <div class="wrapper">
      <div class="backNav desktop"></div>

      <ion-app>
        <Navbar :class="{desktop:isMobile}"/>

          <transition name="fade">
            <router-view></router-view>
          </transition>

          <transition name="slide">
            <router-view name="slideOut"></router-view>
          </transition>

      </ion-app>

      <Footer/>
    </div>
</template>



<script>
import Navbar from '../module/Navbar'
import Footer from '../module/Footer'
import AreasStore from '../AreasStore';
import CatMixin from './category/CatMixin'


export default {
  name:"admin",
  store:AreasStore,
    components:{
        Navbar,
        Footer
    }, 
    mixins: [
      CatMixin
    ],
};
</script>
